homeHandler = {
    $homeCarousel : $('.hero-slider'),
    $heroVideo : $('.hero-video'),
    $section : $('section'),
    $menus : {
        $menuLink : $('.menu-link'),
        $menuPanel : $('.menu-panel'),
        $closePanel : $('.close-panel'),
        $smallMenu : $('.small-menu-name-container'),
        $smallAccor : $('.small-menu-name-container').find('.accordion'),
        $smallTitle : $('.small-menu-name-container').find('.small-menu-title'),
    },

    $privateDine : {
        $panel : $('.panel-private-dine'),
        $panelContainer : $('.private-content-container'),
        $carousel   : $('.panel-private-dine').find('.dine-carousel'),
        $headLink   : $('.panel-private-dine').find('.head-link'),
        arrowPos : function() {
            var self = this;

            /*
            var pos = (($(window).outerWidth() - self.$carousel.find('.dine-grid').width()) / 2) - 17;

            self.$carousel.find('.flickity-prev-next-button.previous').css({
                'left' : pos
            });
            self.$carousel.find('.flickity-prev-next-button.next').css({
                'right' : pos
            });*/
        },
    },

    $specialEvents : {
        $panel : $('.panel-special-event'),
        $seItem : $('.panel-special-event').find('.se-item'),
        $seContainer : $('.panel-special-event').find('.se-item-container')
    },

    $press : {
        $carousel : $('.press-carousel')
    },

    resizeEvents: function(){
        var self = this;
        var bottomPos = mainHandler.footer.$smallFooter.outerHeight();
        self.$menus.$menuPanel.css({
            'bottom' : bottomPos,
        });

        self.$privateDine.$panelContainer.each(function() {
            var thisPanel = $(this);
            var newHeight     = self.$privateDine.$panel.height();
            thisPanel.css({
                'min-height': newHeight,
            });
        });

        
        self.$homeCarousel.find('.carousel-cell, video, .content').css({
            'height': $(window).innerHeight()+'px'
        }) 

        self.countHeightItem($('.se-item.is-active .item-container'));
    },

    countHeightItem: function($itemContainer){
        let height = 0;
        if ($itemContainer) {
            $itemContainer.children().each(function(){
                height += $(this).outerHeight(true);
            })
            $itemContainer.css({'height': height+'px'});
        }
    },

    init : function () {
        var self = this;

        if (self.$homeCarousel) {
            var $carouselLeft = self.$homeCarousel.flickity({
                cellSelector: '.carousel-cell',
                pageDots: false,
                prevNextButtons: false,
                percentPosition: false,
                imagesLoaded: true,
                fade: true,
                autoPlay: 4500,
                selectedAttraction: 0.009,
                on: {
                    staticClick: function(event, pointer, cellElement, cellIndex ){
                        if ( !cellElement ) {
                            return;
                        }
                        animateHandler.scrollToFirstHeroSection();
                    },
                    ready: function(){
                        self.$homeCarousel.removeClass('initial-load');
                    }
                }
            });
            let tmp = $(window).width();
            $(window).on('resize', function(){
                setTimeout(() => {
                    if ((tmp !== $(window).width()) && (animateHandler.isInSection == false)) {
                        $carouselLeft.flickity('resize');
                    }
                }, 300);    
            })
        }

        if (self.$heroVideo.length > 0) {
            self.$heroVideo[0].play();
        }
        
        self.$menus.$menuLink.on('click', function(e) {
            if ($(this).hasClass('menu-main')) {
                mainHandler.setDisableScrolling(true);
                e.preventDefault();
            }

            var slug = $(this).data('menu-slug');
            var $menuTarget = self.$menus.$menuPanel.find('[data-menu="'+slug+'"]');

            if ($menuTarget) {
                self.$menus.$menuPanel.find('[data-menu]').removeClass('is-active');
                $menuTarget.addClass('is-active');
            }

            if (Foundation.MediaQuery.only('small') && ($(this).hasClass('small-size') || $(this).hasClass('menu-main'))) {
                self.$menus.$smallAccor.foundation('up', self.$menus.$smallAccor.find('.accordion-content'));
                self.$menus.$smallAccor.find('.menu-link').removeClass('hide');
                self.$menus.$smallAccor.find('.menu-link[data-menu-slug="'+slug+'"]').addClass('hide');

                var menuFile = $(this).data('file');

                if (menuFile) {
                    self.$menus.$smallMenu.find('.menu-file').removeClass('hide');
                    self.$menus.$smallMenu.find('.menu-file').attr('href', menuFile);
                } else {
                    self.$menus.$smallMenu.find('.menu-file').addClass('hide');
                }

                var menuTitle = $(this).children().first().text();
                menuTitle = (menuTitle == undefined) ? $(this).text() : menuTitle;
                self.$menus.$smallTitle.html(menuTitle);
            }

            var $dishesCell = $(this).closest('.menu-grid-container').find('.dishes-cell');
            if ($dishesCell.length > 0) {
                $dishesCell[0].scrollTo({ top: 0, behavior: 'smooth' })
            }
        });

        /*
        self.$menus.$closePanel.on('click', function(e) {
            e.preventDefault();

            self.$menus.$menuPanel.removeClass('is-showing');
            //$('html').removeClass('disable-scroll');
            mainHandler.setDisableScrolling();
        });
        */

        if (self.$privateDine.$carousel) {
            self.$privateDine.$carousel.flickity({
                cellSelector: '.carousel-item',
                cellAlign: 'left',
                pageDots: false,
                fade: true,
                wrapAround: false,
                prevNextButtons: true,
                draggable: false,
                //selectedAttraction: 0.009,
                arrowShape: 'M41.7344 73.8402C42.3983 74.4405 42.7303 75.1909 42.7303 76.0914C42.7303 76.9919 42.3983 77.7423 41.7344 78.3427C41.1309 78.943 40.3916 79.2581 39.5165 79.2882C38.6413 79.3182 37.902 79.003 37.2985 78.3427L0.995833 41.8728C0.331941 41.2725 0 40.5371 0 39.6666C0 38.7961 0.331941 38.0307 0.995833 37.3703L37.2985 0.90049C37.902 0.300156 38.6413 0 39.5165 0C40.3916 0 41.1309 0.300156 41.7344 0.90049C42.3983 1.56085 42.7303 2.32627 42.7303 3.19674C42.7303 4.06722 42.3983 4.80261 41.7344 5.40294L11.9569 36.2394L95.6056 36.2394C96.5721 36.2394 97.3971 36.5811 98.0805 37.2646C98.7639 37.948 99.1056 38.7729 99.1056 39.7394C99.1056 40.7059 98.7639 41.5309 98.0805 42.2143C97.3971 42.8977 96.5721 43.2394 95.6056 43.2394L12.1845 43.2394L41.7344 73.8402L41.7344 73.8402Z',
                on: {
                    ready: function() {
                        self.$privateDine.arrowPos();
                    },
                    resize: function() {
                        self.$privateDine.arrowPos();
                    },
                    change: function( index ) {
                        self.$privateDine.$headLink.parent().removeClass('is-active');
                        self.$privateDine.$headLink.parent().eq(index).addClass('is-active');
                    },
                }
            });
        }

        self.$privateDine.$headLink.on('click', function(e) {
            e.preventDefault();

            var index = $(this).parents('.head-nav').index();
            self.$privateDine.$carousel.flickity('select', index);
            self.$privateDine.$panel.find('.head-link').parents('.head-nav').removeClass('is-active');
            $(this).parents('.head-nav').addClass('is-active');
        });

        jQuery(document).on('gform_post_render', function(event, form_id, current_page){
            if (form_id == 2) {
                var html = $('#gform_fields_2').html();
                var newHtml = html.replace('<fieldset', '<div');
                newHtml = newHtml.replace('</fieldset', '</div');
                newHtml = newHtml.replace('<legend', '<label');
                newHtml = newHtml.replace('</legend', '</label');
                $('#gform_fields_2').html(newHtml);
            }
        });

        self.$specialEvents.$seItem.each(function() {
            if (Foundation.MediaQuery.only('small')) {
                if ($(this).hasClass('small-item')) {
                    var scrollPos = ($(this).hasClass('first-se')) ? 0 : $(this).offset().left;

                    $(this).data('left-pos', scrollPos);
                }
            }

            $(this).on('click', function(e) {
                var seSlug = $(this).data('se-slug');
    
                self.$specialEvents.$panel.find('[data-se-slug]').removeClass('is-active');
                self.$specialEvents.$panel.find('[data-se-slug="'+seSlug+'"]').addClass('is-active');
                self.$specialEvents.$panel.find('[data-se-slug]').find('.item-container').css({'height': '0'});

                var $itemContainer = self.$specialEvents.$panel.find('[data-se-slug="'+seSlug+'"]').find('.item-container');
                self.countHeightItem($itemContainer);
                // var height = 0;
                // $itemContainer.children().each(function(){
                //     height += $(this).outerHeight(true);
                // })
                // $itemContainer.css({'height': height+'px'});
    
                if (Foundation.MediaQuery.only('small')) {
                    var scrollTo = $(this).data('left-pos');

                    self.$specialEvents.$seContainer.animate({
                        scrollLeft: scrollTo
                    }, 400);
                }
            });
        });

        if (self.$press.$carousel) {
            var groupCells = 3;
            if (Foundation.MediaQuery.only('small')) {
                groupCells = 1;
            }

            self.$press.$carousel.flickity({
                cellSelector: '.carousel-item',
                cellAlign: 'left',
                groupCells: groupCells,
                pageDots: false,
                fade: true,
                wrapAround: true,
                prevNextButtons: true,
                draggable: false,
                selectedAttraction: 0.017,
                arrowShape: { 
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 65, y2: 50,
                    x3: 15
                  }
            });
        }

        /*
        self.$privateDine.$panelContainer.each(function() {
            if (Foundation.MediaQuery.only('small')) {
                var headHeight = $(this).find('.dine-header').outerHeight();
                $(this).find('.dine-carousel').css('top', headHeight);
            }
        });
        */

        self.resizeEvents();
        let tempW = $(window).width();
        $(window).on('resize', function() {
            if (tempW !== $(window).width()) {
                self.resizeEvents();
            }
        });
    }
}